import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListTile } from 'vuetify/lib/components/VList';
import { VListTileAction } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VCard,
    [
      _c(
        VCardTitle,
        { attrs: { "primary-title": "" } },
        [
          _c(
            VLayout,
            [
              _c(
                VFlex,
                { staticClass: "pt-4 pl-4", attrs: { xs8: "" } },
                [
                  _c(VLayout, { staticClass: "H5-Primary-Left" }, [
                    _vm._v("CentricOS Local Menu Group Permissions")
                  ]),
                  _c(
                    VLayout,
                    [
                      _c(VTextField, {
                        staticClass: "Brand-Not-Selected-Error",
                        attrs: {
                          value:
                            _vm.selectedBrands.length ||
                            _vm.selectedLocalMenuGroups.length
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                VFlex,
                { staticStyle: { cursor: "pointer" }, attrs: { xs4: "" } },
                [
                  _vm.selectedLocalMenuGroups.length > 0
                    ? _c(
                        VLayout,
                        {
                          staticClass: "mt-3 mr-5 noselect",
                          attrs: { "justify-end": "" },
                          on: {
                            click: function($event) {
                              _vm.isAllCollapsed = !_vm.isAllCollapsed
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "Body-2-Primary-On-Surface-Left" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.isAllCollapsed
                                      ? "Expand All"
                                      : "Collapse All"
                                  ) +
                                  "\n          "
                              )
                            ]
                          ),
                          _c(VIcon, { staticStyle: { color: "#0d73d8" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.isAllCollapsed
                                  ? "mdi-chevron-down"
                                  : "mdi-chevron-up"
                              )
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "loading-wrapper",
        { attrs: { loading: _vm.loading } },
        [
          _c(
            VLayout,
            { staticClass: "v-card-content" },
            [
              _c(
                VFlex,
                [
                  _vm.selectedLocalMenuGroups.length ||
                  _vm.missingLocalMenuGroups.length
                    ? _c(
                        "div",
                        [
                          _c(
                            VLayout,
                            [
                              _c(
                                VFlex,
                                { attrs: { xs8: "" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      label: "Search Local Menu Groups",
                                      "prepend-icon": "mdi-magnify",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.search,
                                      callback: function($$v) {
                                        _vm.search = $$v
                                      },
                                      expression: "search"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(VFlex, { attrs: { xs4: "" } })
                            ],
                            1
                          ),
                          _c(
                            VLayout,
                            {
                              staticStyle: { "min-height": "450px" },
                              attrs: { column: "" }
                            },
                            [
                              _c(
                                VFlex,
                                { attrs: { xs12: "" } },
                                _vm._l(
                                  _vm.orderBy(
                                    _vm.filterBy(
                                      _vm.selectedLocalMenuGroups,
                                      _vm.search,
                                      "name"
                                    ),
                                    "name"
                                  ),
                                  function(localMenuGroup, sIndex) {
                                    return _c(
                                      VLayout,
                                      {
                                        key: sIndex,
                                        staticClass:
                                          "LocalMenuGroup-Permissions-Container px-3 mt-2 mb-2 noselect"
                                      },
                                      [
                                        _c(
                                          VFlex,
                                          [
                                            _c(
                                              VLayout,
                                              [
                                                _c(
                                                  VFlex,
                                                  {
                                                    staticStyle: {
                                                      cursor: "pointer"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.expand(
                                                          localMenuGroup
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(VLayout, [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "H6-Secondary-Left"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                localMenuGroup.name ||
                                                                  "Untitled"
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ]
                                                      )
                                                    ]),
                                                    _c(
                                                      VLayout,
                                                      [
                                                        _c(VTextField, {
                                                          staticClass:
                                                            "Brand-Not-Selected-Error",
                                                          attrs: {
                                                            value: _vm.getSelectedBrands(
                                                              localMenuGroup
                                                            ).length
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  VFlex,
                                                  { attrs: { xs4: "" } },
                                                  [
                                                    _c(
                                                      VLayout,
                                                      {
                                                        attrs: {
                                                          "justify-end": ""
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          VFlex,
                                                          [
                                                            _c(
                                                              VLayout,
                                                              {
                                                                attrs: {
                                                                  "justify-end":
                                                                    ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  VBtn,
                                                                  {
                                                                    attrs: {
                                                                      flat: "",
                                                                      color:
                                                                        "#090c9b"
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.removeLocalMenuGroup(
                                                                          localMenuGroup.id
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      VIcon,
                                                                      {
                                                                        staticClass:
                                                                          "mr-1",
                                                                        attrs: {
                                                                          left:
                                                                            ""
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "mdi-delete-outline"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(
                                                                      "REMOVE\n                            "
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          VFlex,
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.expand(
                                                                  localMenuGroup
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              VLayout,
                                                              {
                                                                staticStyle: {
                                                                  cursor:
                                                                    "pointer",
                                                                  "margin-top":
                                                                    "0px"
                                                                },
                                                                attrs: {
                                                                  "justify-center":
                                                                    ""
                                                                }
                                                              },
                                                              [
                                                                _c(VIcon, [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .expansionPanelValues[
                                                                        localMenuGroup
                                                                          .id
                                                                      ]
                                                                        ? "mdi-chevron-up"
                                                                        : "mdi-chevron-down"
                                                                    )
                                                                  )
                                                                ])
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            !_vm.expansionPanelValues[
                                              localMenuGroup.id
                                            ]
                                              ? _c(
                                                  VLayout,
                                                  {
                                                    staticClass: "my-1",
                                                    staticStyle: {
                                                      cursor: "pointer"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.expand(
                                                          localMenuGroup
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(VFlex, [
                                                      _vm._v(
                                                        "\n                      User has access to \n                      "
                                                      ),
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            localMenuGroup.totalSelected
                                                          ) +
                                                            "/" +
                                                            _vm._s(
                                                              localMenuGroup.total
                                                            ) +
                                                            " brands"
                                                        )
                                                      ]),
                                                      _vm._v(
                                                        "\n                       at " +
                                                          _vm._s(
                                                            localMenuGroup.name ||
                                                              "Untitled"
                                                          ) +
                                                          "\n                    "
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              : _c(
                                                  VLayout,
                                                  {
                                                    staticClass: "pl-2",
                                                    attrs: {
                                                      "justify-start": ""
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      VFlex,
                                                      [
                                                        _c(
                                                          VLayout,
                                                          {
                                                            staticStyle: {
                                                              "margin-top":
                                                                "-20px",
                                                              "margin-bottom":
                                                                "-15px"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.toggleBrandsSelection(
                                                                  localMenuGroup.id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c(VCheckbox, {
                                                              attrs: {
                                                                label:
                                                                  "Select All",
                                                                value: true,
                                                                disabled: ""
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .selectedLocalMenuGroupsCache[
                                                                    localMenuGroup
                                                                      .id
                                                                  ]
                                                                    .isAllSelected,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .selectedLocalMenuGroupsCache[
                                                                      localMenuGroup
                                                                        .id
                                                                    ],
                                                                    "isAllSelected",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "selectedLocalMenuGroupsCache[localMenuGroup.id].isAllSelected"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          VLayout,
                                                          [
                                                            _c(VTextField, {
                                                              staticClass:
                                                                "Brand-Not-Selected-Error",
                                                              attrs: {
                                                                rules: _vm.appSelectionRules(
                                                                  localMenuGroup.totalSelected ||
                                                                    localMenuGroup.isAllSelected
                                                                ),
                                                                value: Object.keys(
                                                                  _vm
                                                                    .selectedLocalMenuGroupsCache[
                                                                    localMenuGroup
                                                                      .id
                                                                  ].brands
                                                                )
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          VLayout,
                                                          [
                                                            _c(
                                                              VList,
                                                              _vm._l(
                                                                _vm.getBrands(
                                                                  localMenuGroup.id
                                                                ),
                                                                function(
                                                                  brand,
                                                                  bIndex
                                                                ) {
                                                                  return _c(
                                                                    VListTile,
                                                                    {
                                                                      key: bIndex,
                                                                      attrs: {
                                                                        label:
                                                                          brand.name
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        VListTileAction,
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              on: {
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.toggleBrandSelection(
                                                                                    localMenuGroup.id
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                VCheckbox,
                                                                                {
                                                                                  attrs: {
                                                                                    label:
                                                                                      "" +
                                                                                      brand.name,
                                                                                    disabled:
                                                                                      ""
                                                                                  },
                                                                                  model: {
                                                                                    value:
                                                                                      _vm
                                                                                        .selectedLocalMenuGroupsCache[
                                                                                        localMenuGroup
                                                                                          .id
                                                                                      ]
                                                                                        .brands[
                                                                                        brand
                                                                                          .id
                                                                                      ]
                                                                                        .isSelected,
                                                                                    callback: function(
                                                                                      $$v
                                                                                    ) {
                                                                                      _vm.$set(
                                                                                        _vm
                                                                                          .selectedLocalMenuGroupsCache[
                                                                                          localMenuGroup
                                                                                            .id
                                                                                        ]
                                                                                          .brands[
                                                                                          brand
                                                                                            .id
                                                                                        ],
                                                                                        "isSelected",
                                                                                        $$v
                                                                                      )
                                                                                    },
                                                                                    expression:
                                                                                      "\n                                    selectedLocalMenuGroupsCache[localMenuGroup.id].brands[\n                                      brand.id\n                                    ].isSelected\n                                  "
                                                                                  }
                                                                                }
                                                                              )
                                                                            ],
                                                                            1
                                                                          )
                                                                        ]
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                }
                                                              ),
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              ),
                              _vm.missingLocalMenuGroups.length
                                ? _c(
                                    VFlex,
                                    { attrs: { xs12: "" } },
                                    [
                                      _c(
                                        VLayout,
                                        {
                                          staticClass:
                                            "ml-1 mr-1 mb-3 H7-Secondary-Left font-weight-bold",
                                          staticStyle: { color: "#ea526f" }
                                        },
                                        [
                                          _vm._v(
                                            "The following Local Menu Group ID(s) can no longer be found and may have been\n                deleted, consider removing the permissions below to avoid conflicts. If this is\n                incorrect, please contact a system administrator:"
                                          )
                                        ]
                                      ),
                                      _vm._l(
                                        _vm.missingLocalMenuGroups,
                                        function(
                                          missingLocalMenuGroupId,
                                          index
                                        ) {
                                          return _c(
                                            VLayout,
                                            {
                                              key: index,
                                              staticClass:
                                                "LocalMenuGroup-Permissions-Container px-3 mt-2 mb-2 noselect"
                                            },
                                            [
                                              _c(
                                                VFlex,
                                                [
                                                  _c(
                                                    VLayout,
                                                    [
                                                      _c(
                                                        VFlex,
                                                        [
                                                          _c(
                                                            VTooltip,
                                                            {
                                                              attrs: {
                                                                top: "",
                                                                "nudge-right":
                                                                  "100",
                                                                "close-delay":
                                                                  "1000"
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "activator",
                                                                    fn: function(
                                                                      ref
                                                                    ) {
                                                                      var on =
                                                                        ref.on
                                                                      var attrs =
                                                                        ref.attrs
                                                                      return [
                                                                        _c(
                                                                          VLayout,
                                                                          _vm._g(
                                                                            _vm._b(
                                                                              {
                                                                                staticClass:
                                                                                  "H7-Secondary-Left ma-0"
                                                                              },
                                                                              "v-layout",
                                                                              attrs,
                                                                              false
                                                                            ),
                                                                            on
                                                                          ),
                                                                          [
                                                                            _vm._v(
                                                                              "\n                            " +
                                                                                _vm._s(
                                                                                  missingLocalMenuGroupId
                                                                                    .slice(
                                                                                      0,
                                                                                      50
                                                                                    )
                                                                                    .concat(
                                                                                      "..."
                                                                                    )
                                                                                ) +
                                                                                "\n                          "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                true
                                                              )
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    missingLocalMenuGroupId
                                                                  )
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        VFlex,
                                                        { attrs: { xs4: "" } },
                                                        [
                                                          _c(
                                                            VLayout,
                                                            {
                                                              attrs: {
                                                                "justify-end":
                                                                  ""
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                VFlex,
                                                                [
                                                                  _c(
                                                                    VLayout,
                                                                    {
                                                                      attrs: {
                                                                        "justify-end":
                                                                          ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        VBtn,
                                                                        {
                                                                          attrs: {
                                                                            flat:
                                                                              "",
                                                                            color:
                                                                              "#090c9b"
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.removeLocalMenuGroup(
                                                                                missingLocalMenuGroupId
                                                                              )
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            VIcon,
                                                                            {
                                                                              staticClass:
                                                                                "mr-1",
                                                                              attrs: {
                                                                                left:
                                                                                  ""
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "mdi-delete-outline"
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            "REMOVE\n                            "
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              ),
                                                              _c(VFlex, {
                                                                attrs: {
                                                                  xs3: "",
                                                                  lg4: ""
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        }
                                      )
                                    ],
                                    2
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            VLayout,
                            {
                              staticClass: "pl-4 mt-4 mb-2 mr-5",
                              attrs: { "justify-start": "" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "Body-2-Primary-On-Surface-Left noselect",
                                  staticStyle: {
                                    "text-decoration": "underline",
                                    cursor: "pointer"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.dialog = true
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              Edit Local Menu Group Permissions\n            "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "Body-1-Primary-Left Permissions-Link",
                          on: {
                            click: function($event) {
                              _vm.dialog = true
                            }
                          }
                        },
                        [
                          _vm.selectedLocalMenuGroups.length === 0
                            ? _c("div", [_vm._v("Choose Local Menu Groups")])
                            : _vm._e()
                        ]
                      ),
                  _c("permissions-dialog", {
                    attrs: {
                      dialog: _vm.dialog,
                      selectedLocalMenuGroups: _vm.selectedLocalMenuGroupsCache
                    },
                    on: {
                      "update:dialog": function($event) {
                        _vm.dialog = $event
                      },
                      "update:selectedLocalMenuGroups": function($event) {
                        _vm.selectedLocalMenuGroupsCache = $event
                      },
                      "update:selected-local-menu-groups": function($event) {
                        _vm.selectedLocalMenuGroupsCache = $event
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }